import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useDebounce } from 'use-debounce';
import { apiService } from '../../../../services/ApiService';
import Autocomplete from '../../../../components/Inputs/Autocomplete/Autocomplete';

const StationInput = ({
  isDisabled,
  isValid,
  onChange,
  wrapperProps,
  initialInputValue,
  value,
}) => {
  const [inputValue, setInputValue] = useState(initialInputValue);

  const [selectedOption, setSelectedOption] = useState(() => {
    return initialInputValue && value
      ? { label: initialInputValue, value }
      : undefined;
  });

  useEffect(() => {
    if (!selectedOption && initialInputValue && value) {
      setSelectedOption({ label: initialInputValue, value });
    }
  }, [selectedOption, initialInputValue, value]);

  const [debouncedInputValue] = useDebounce(inputValue, 500);

  const { data: stations, isLoading } = useQuery({
    queryKey: ['stations-autocomplete', debouncedInputValue],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      let data = {
        limit: 70,
        ...(debouncedInputValue?.length > 0 && { search: debouncedInputValue }),
      };

      return await apiService.getStations(data);
    },
  });

  const StationOptions =
    stations?.data?.map((terminal) => ({
      label: terminal.name,
      value: terminal.id,
    })) || [];

  return (
    <Autocomplete
      isValid={isValid}
      isDisabled={isDisabled}
      options={StationOptions}
      isLoading={isLoading}
      setInputValue={setInputValue}
      onChange={onChange}
      inputValue={inputValue}
      setSelectedOption={setSelectedOption}
      selectedOption={selectedOption}
      wrapperProps={wrapperProps}
      placeholder="Select Station"
    />
  );
};

export default StationInput;
